<template>
  <div>
    <LayoutHeader
      activeNav="评审专家库"
      :topColor="topColor"
      bannerType="header expert"
      :height="250"
    />
    <div class="container">
      <section class="left">
        <div class="btns">
          <img
            @click="toUpload"
            src="../../assets/images/index/index-button-ZJ_01@2x.png"
            alt=""
          />
          <img
            @click="select"
            src="../../assets/images/index/index-button-ZJ_02@2x.png"
            alt=""
          />
        </div>
        <div class="expert">
          <img :src="newest.img_avatar_full" alt="" />
          <h1>{{ newest.name }}</h1>
          <p>
            {{ newest.synopsis }}
          </p>
          <h2>
            {{ newest.now_job }}
          </h2>
          <div v-if="expertReview.length !== 0">
            <h3>正在参与评审团</h3>
            <h4
              v-for="(review_item, review_index) in expertReview"
              :key="review_index"
            >
              -{{ review_item.name }}
            </h4>
          </div>
        </div>
      </section>
      <section class="right">
        <h1>全部（{{ total }}）</h1>
        <ul class="letters">
          <li
            v-for="(letter_item, letter_index) in lettersList"
            :class="letter_item === activeLetter ? 'activeLetter' : ''"
            :key="letter_index"
            @click="changeLetter(letter_item)"
          >
            {{ letter_item }}
          </li>
        </ul>
        <ul v-if="expertList.length !== 0" class="experts">
          <li
            v-for="(expert_item, expert_index) in expertList"
            :key="expert_index"
            @click="toVisit(expert_item)"
          >
            <img
              v-if="expert_item.img_avatar_full"
              :src="expert_item.img_avatar_full"
              alt=""
            />
            <img
              v-else
              src="../../assets/images/user/yh-icon-touxiang@2x.png"
              alt=""
            />
            <div>{{ expert_item.name }}</div>
          </li>
        </ul>

        <LayoutNoData v-else />

        <section class="paging">
          <img
            @click="changePageBtn('pre')"
            style="margin-right: 24px"
            src="../../assets/images/paging/icon-page-pre@2x.png"
            alt=""
          />
          <div>第{{ page }}页</div>
          <img
            @click="changePageBtn('next')"
            style="margin-left: 24px; margin-right: 24px"
            src="../../assets/images/paging/icon-page-next@2x.png"
            alt=""
          />
          <input v-model="jumpPage" type="text" />
          <span
            @click="changePageInput"
            style="cursor: pointer; margin-right: 24px"
            >跳转到该页</span
          >
          <span>共{{ pages }}页</span>
        </section>
      </section>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers("Expert");
import Storage from "../../xx-vue/utils/storage";
export default {
  data() {
    return {
      topColor: "",
      lettersList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ], //字母列表
      activeLetter: "", //当前激活的字母
      jumpPage: "",
      userInfo: null,
    };
  },
  computed: {
    ...mapState(["expertList", "page", "expertReview", "total", "newest"]),
    ...mapGetters(["pages"]),
  },
  mounted() {
    this.initScroll();
    this.getExpertList();
    const userInfo = Storage.getStorage("info");
    if (userInfo) {
      this.userInfo = userInfo;
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  watch: {
    page() {
      this.getExpertList();
    },
  },
  methods: {
    ...mapActions(["getExpertList", "getExpertByFirst"]),
    ...mapMutations(["changePage"]),
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //更改激活Nav
    changeActive(val) {
      this.activeNav = val;
    },
    //上传资料
    toUpload() {
      if (this.userInfo) {
        this.$router.push("/expert/expert_upload");
      } else {
        this.$message.error("请登录");
        this.$router.push("/login");
      }
    },
    //查看他人资料
    toVisit(item) {
      this.$router.push(`/user/visit?expert_id=${item.id}`);
    },
    //切换首字母
    changeLetter(val) {
      this.activeLetter = val;
      this.getExpertByFirst(val);
    },
    //换页按钮
    changePageBtn(val) {
      switch (val) {
        case "pre":
          if (this.page !== 1) {
            this.changePage(this.page - 1);
          }
          break;
        case "next":
          if (this.page !== this.pages) {
            this.changePage(this.page + 1);
          }
          break;
      }
    },
    //换页输入
    changePageInput() {
      const page = parseInt(this.jumpPage);
      if (!isNaN(page)) {
        this.changePage(page);
      }
    },
    //抽选专家
    select() {
      this.$router.push("/expert/select_expert");
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 42px 0;
  display: flex;
  justify-content: space-between;

  .left {
    width: 400px;
    .btns {
      margin-bottom: 12px;
      img {
        width: 50%;
        height: 64px;
        cursor: pointer;
      }
    }
    .expert {
      padding: 28px 52px;
      background-color: #f6f6f6;
      img {
        display: block;
        margin: 0 auto;
        width: 260px;
        height: 320px;
        margin-bottom: 20px;
      }
      h1 {
        text-align: center;
        font-size: 18px;
        color: #333333;
        margin-bottom: 16px;
      }
      p {
        font-size: 16px;
        line-height: 24px;
        color: #656565;
        margin-bottom: 24px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      h2 {
        color: #333333;
        margin-bottom: 46px;
        font-weight: normal;
        font-size: 16px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      h3 {
        font-size: 18px;
        color: #a32225;
        margin-bottom: 14px;
        font-weight: normal;
      }
      h4 {
        font-size: 16px;
        color: #989898;
        font-weight: normal;
      }
    }
  }

  .right {
    width: 760px;
    h1 {
      color: #f2252f;
      font-size: 20px;
      margin-bottom: 30px;
    }

    .activeLetter {
      color: #f2252f !important;
    }

    .letters {
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid #dddddd;
      padding-bottom: 16px;
      margin-bottom: 22px;
      li {
        font-weight: bold;
        color: #333333;
        cursor: pointer;
      }
    }

    .experts {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 18%;
        height: 172px;
        margin-right: 2%;
        position: relative;
        margin-bottom: 18px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
        div {
          width: 100%;
          position: absolute;
          bottom: 0;
          padding: 10px 0;
          text-align: center;
          background-color: rgba(0, 0, 0, 0.5);
          color: #ffffff;
          font-size: 14px;
        }
      }
    }

    .paging {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 50px;
      & > img {
        width: 16px;
        height: 20px;
        cursor: pointer;
      }

      & > div {
        padding: 0 34px;
      }

      input {
        width: 30px;
        height: 30px;
        text-indent: 6px;
        margin-right: 4px;
      }
    }
  }
}
</style>